class IconCacheService {
    private static instance: IconCacheService;
    private iconCache = new Map<string, Promise<string>>();

    private sizeMapping = {
        s: '20',
        m: '24',
        l: '32',
        xl: '48',
    };

    private constructor() {}

    static getInstance(): IconCacheService {
        if (!IconCacheService.instance) {
            IconCacheService.instance = new IconCacheService();
        }
        return IconCacheService.instance;
    }

    getIcon(icon: string, size: string, skipCaching?: boolean): Promise<string> {
        const cacheKey = `${icon}-${size}`;
        const cachedIcon = sessionStorage.getItem(cacheKey);

        if (cachedIcon) {
            return Promise.resolve(cachedIcon);
        }

        if (this.iconCache.has(cacheKey)) {
            return this.iconCache.get(cacheKey);
        }

        const differentBasePath = (window as any).sewIconPath;
        let iconUrl = '';

        if (differentBasePath) {
            iconUrl = `${differentBasePath}/${icon}-${this.sizeMapping[size]}.svg`;
        } else if (icon.includes('.svg')) {
            iconUrl = icon;
        } else {
            const baseUrl = 'https://media.sew-eurodrive.com/sew_master/media/design-system/icons';
            iconUrl = `${baseUrl}/${icon}/${icon}-${this.sizeMapping[size]}.svg`;
        }

        const fetchPromise = fetch(iconUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Could not find icon ${icon} with size ${size}.`);
                }
                return response.text();
            })
            .then(svg => {
                !skipCaching && sessionStorage.setItem(cacheKey, svg);
                return svg;
            })
            .catch(e => {
                this.iconCache.delete(cacheKey); // Remove the failed request from the cache
                throw e;
            });

        !skipCaching && this.iconCache.set(cacheKey, fetchPromise);
        return fetchPromise;
    }
}

export const iconCacheService = IconCacheService.getInstance();
